import Vue from 'vue'
import App from './App'
import router from './router'
import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/music'

// 按需引入Element UI组件，减少打包体积
// import { Button, Input, Select, Carousel, CarouselItem, Rate, Pagination, Dialog, Form, FormItem, Option, Upload } from 'element-ui';
// Vue.use(Button)
// Vue.use(Input)
// Vue.use(Select)
// Vue.use(Carousel)
// Vue.use(CarouselItem)
// Vue.use(Rate)
// Vue.use(Pagination)
// Vue.use(Dialog)
// Vue.use(Form)
// Vue.use(FormItem)
// Vue.use(Option)
// Vue.use(Upload)

Vue.use(element)

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'categoryNum') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}

// 按需引入less，减少打包体积
// import less from 'less'
// Vue.use(less)

import http from './utils/http';
Vue.prototype.$http = http;



Vue.config.productionTip = false

// 监听元素是否进入视图（添加防抖优化，解决闪屏问题）
Vue.directive('appear-animation', {
  bind(el, binding) {
    // 兼容低版本ES：用Object.assign合并配置，替代对象展开运算符
    const defaultOptions = {
      appearClass: 'slide-in', // 默认入场类名
      intersectionOptions: {}, // 交叉观察器配置
      debounceDelay: 150, // 防抖延迟时间（默认150ms，可根据需求调整）
    };
    // 合并默认配置和用户传入的配置（用户配置优先级更高）
    const options = Object.assign({}, defaultOptions, binding.value);

    let hasEntered = false; // 追踪元素是否已进入视图
    let debounceTimer = null; // 防抖定时器
    let observer = null; // 交叉观察器实例

    // 防抖处理函数：延迟执行类名操作，避免频繁切换
    const debounceHandle = (isIntersecting) => {
      // 清除上一次未执行的定时器
      clearTimeout(debounceTimer);
      // 延迟执行操作
      debounceTimer = setTimeout(() => {
        requestAnimationFrame(() => {
          if (isIntersecting && !hasEntered) {
            el.classList.add(options.appearClass);
            hasEntered = true;
          } else if (!isIntersecting && hasEntered) {
            el.classList.remove(options.appearClass);
            hasEntered = false;
          }
        });
      }, options.debounceDelay);
    };

    // 创建交叉观察器
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // 用防抖函数包裹核心逻辑
        debounceHandle(entry.isIntersecting);
      });
    }, options.intersectionOptions);

    // 开始观察目标元素
    observer.observe(el);

    // 存储实例到元素上，方便unbind时销毁
    el._appearAnimation = { observer, debounceTimer };
  },

  // 指令解绑时销毁资源（避免内存泄漏）
  unbind(el) {
    const { observer, debounceTimer } = el._appearAnimation || {};
    if (observer) observer.disconnect(); // 停止观察
    if (debounceTimer) clearTimeout(debounceTimer); // 清除定时器
    delete el._appearAnimation; // 移除元素上的存储属性
  }
});

// 图片懒加载指令
Vue.directive('lazy', {
  bind(el, binding) {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.src = binding.value;
          observer.unobserve(el);
        }
      });
    }, options);

    observer.observe(el);

    el._lazyObserver = observer;
  },
  unbind(el) {
    if (el._lazyObserver) {
      el._lazyObserver.disconnect();
    }
  }
});

// 在main.js中添加以下代码
new Vue({
  el: '#app',
  store,
  render: h => h(App),
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js